<template>
<div class="WriteoffList bgc padding-20">
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="待核销" name="0">
            <writeoffListItem ref="writeoffList0" @getList="_refresh"></writeoffListItem>
        </el-tab-pane>
        <el-tab-pane label="已核销" name="1">
            <writeoffListItem ref="writeoffList1" @getList="_refresh"></writeoffListItem>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import WriteoffListItem from 'views/brandBusiness/activityMgt/writeoff/components/writeoffList.vue'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'BBWriteoffList',
    data() {
        return {
            activeName: '0'
        }
    },
    mounted() {
        if (!this.isRefresh) {
            this.$nextTick(() => {
                this.$refs['writeoffList' + this.activeName].getList(this.activeName)
            })
        }
    },
    activated() {
        if (this.isRefresh) {
            if (this.isRefresh === 2) {
                this.activeName = '0'
                this.$refs['writeoffList0'].initParam()
                this.$refs['writeoffList1'].initParam()
                this.$refs['writeoffList' + this.activeName].getList(this.activeName)
            } else {
                this._refresh()
            }
            this.setIsRefresh(0)
        }
    },
    methods: {
        handleClick() {
            this.$refs['writeoffList' + this.activeName].getList(this.activeName)
        },
        _refresh() {
            this.$refs['writeoffList0']._refresh('0')
            this.$refs['writeoffList1']._refresh('1')
        },
        ...mapActions(['setIsRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['isRefresh'])
    },
    components: {
        WriteoffListItem
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.WriteoffList {
}
</style>
